import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const relocationLineEmailQuery = graphql(`
  query RelocationLineEmail($id: ID!) {
    relocationLineEmail(id: $id) {
      id
      status
      email_from
      email_subject
      email_received_at
      email_text
      failure_reason
      actions {
        type
        line_reference
        region
        sold_by
        confident
        relocation_line_id
        outcome
      }
    }
  }
`);

export type RelocationLineEmailRecord = ResultOf<
  typeof relocationLineEmailQuery
>["relocationLineEmail"];
